import { Activity } from 'types/order';

// Returns true if the activity indicates an order update (excludes claim events)
export const isUpdateActivity = (a?: Activity | null): boolean => {
  if (!a) return false;
  const ev = (a.eventType ?? '').toString().toUpperCase();

  // Exclude ORDER_CREATED and all CLAIM-related events
  if (ev === 'ORDER_CREATED' || ev === '') return false;
  if (ev.startsWith('CLAIM_')) return false;

  return true;
};

export const getLastUpdate = (
  activities?: Activity[] | null,
): string | null => {
  if (!Array.isArray(activities) || activities.length === 0) return null;
  const updates = activities.filter(isUpdateActivity);
  if (updates.length === 0) return null;

  const latest = updates.reduce((acc, curr) => {
    const accTime = acc?.createdAt ? new Date(acc.createdAt).getTime() : 0;
    const currTime = curr?.createdAt ? new Date(curr.createdAt).getTime() : 0;
    return currTime > accTime ? curr : acc;
  });

  return latest?.createdAt ?? null;
};

export const wasOrderUpdated = (activities?: Activity[] | null): boolean => {
  return getLastUpdate(activities) !== null;
};

export const isAddressUpdateActivity = (a?: Activity | null): boolean => {
  if (!a || typeof a.eventType !== 'string') return false;
  const ev = a.eventType.toUpperCase();
  return (
    ev === 'ADDRESS_UPDATED' ||
    (ev.includes('ADDRESS') && ev.includes('UPDATED'))
  );
};

export const getLastAddressUpdate = (
  activities?: Activity[] | null,
): string | null => {
  if (!Array.isArray(activities) || activities.length === 0) return null;
  const updates = activities.filter(isAddressUpdateActivity);
  if (updates.length === 0) return null;

  const latest = updates.reduce((acc, curr) => {
    const accTime = acc?.createdAt ? new Date(acc.createdAt).getTime() : 0;
    const currTime = curr?.createdAt ? new Date(curr.createdAt).getTime() : 0;
    return currTime > accTime ? curr : acc;
  });

  return latest?.createdAt ?? null;
};
